import Hero from '../components/home/Hero';
import CredibilityStrip from '../components/home/CredibilityStrip';
import TransformationsPreview from '../components/home/TransformationsPreview';
import QuoteStrip from '../components/home/QuoteStrip';
import Problem from '../components/home/Problem';
import SignatureServices from '../components/home/SignatureServices';
import WhyMondaine from '../components/home/WhyMondaine';
import WorkshopGallery from '../components/WorkshopGallery';
import CitiesServed from '../components/home/CitiesServed';
import SocialProof from '../components/home/SocialProof';
import LeadMagnet from '../components/home/LeadMagnet';
import FAQ from '../components/home/FAQ';
import FinalCTA from '../components/home/FinalCTA';
import useSEO, { faqJsonLd, serviceJsonLd } from '../hooks/useSEO';
import { FAQS } from '../data/mock';

export default function Home() {
  useSEO({
    title: 'Personal Stylist India — Image Consultant & Personal Shopping Service | Mondaine Style, Bengaluru',
    description: 'Personal Stylist & Image Consultant in India led by Anitya Vatsal (NIFT Bangalore, 14+ years). Personal Styling, Wardrobe Strategy, Personal Shopping Service & Wedding Styling for men in Bengaluru, Chennai, Mumbai & Delhi. Style Diagnosis from \u20B97,500.',
    path: '/',
    jsonLd: [
      faqJsonLd(FAQS),
      serviceJsonLd({
        name: 'Style Diagnosis',
        description: 'A founder-led private styling consultation for men \u2014 wardrobe, body, palette, profession and personal image strategy. Available across India and virtually.',
        slug: '/book-consultation',
        price: '7500',
      }),
    ],
  });
  return (
    <>
      <Hero />
      <CredibilityStrip />
      <TransformationsPreview />
      <QuoteStrip />
      <Problem />
      <SignatureServices />
      <WhyMondaine />
      <WorkshopGallery variant="dark" />
      <CitiesServed />
      <SocialProof />
      <LeadMagnet />
      <FAQ />
      <FinalCTA />
    </>
  );
}
